import { FC } from 'react'

import { Skeleton } from '@syconium/little-miss-figgy'

import { EmbroideryGroupPlaceholder } from '../CartItem/EmbroideryGroupItem/EmbroideryGroupPlaceholder'
import { KitCartItemPlaceholder } from '../CartItem/KitCartItem/KitCartItemPlaceholder'
import { DeleteIconColumn } from '../CartItem/PriceAndDeleteButton/styles'
import { CartEntry, orderKitEntries } from '../utils'

import { Body, Details, Items, PriceSection, QuantityWrapper } from './styles'

// Mirrors `KitGroup`; kit embroidery panels are collapsed, as in the real group
export const KitGroupPlaceholder: FC<{ entries: ReadonlyArray<CartEntry> }> = ({ entries }) => {
  const kitEntries = orderKitEntries(entries)

  return (
    <Body aria-hidden data-testid='kit-group-placeholder'>
      <Details>
        <Skeleton animated height='18px' maxWidth='160px' />
        <DeleteIconColumn>
          <Skeleton animated height='20px' width='20px' />
        </DeleteIconColumn>
      </Details>
      <Details>
        <QuantityWrapper>
          <Skeleton animated height='28px' width='98px' />
        </QuantityWrapper>
        <PriceSection>
          <Skeleton animated height='18px' width='48px' />
        </PriceSection>
      </Details>
      <Items>
        {kitEntries.map(e => (
          <KitCartItemPlaceholder key={e.item.key} />
        ))}
        {kitEntries.map(
          e =>
            e.embroidery && (
              <EmbroideryGroupPlaceholder key={e.embroidery.guid} group={e.embroidery} inKit />
            )
        )}
      </Items>
    </Body>
  )
}
